module.exports = __webpack_public_path__ + "images/gwt-pricing-banner-lms-bg.jpg";